const ChineseHairstudio = {
    beranda: '主页',
    visiMisi: '愿景和使命',
    // cerita: '故事',
    tentangKami: '关于我们',
    lokasi: '地点',
    kontak: '接触',
    karir: '职业',
    lainnya: '其他',
}

export default ChineseHairstudio;